import { LodashExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';

export const PC_RISK_FACTS: { [factName: string]: FactMappingInterface } = {
	totalRisk: {
		extractor: new FactExtractor([new LodashExtractor('risk.risk.total')], risk => {
			return risk * 100;
		})
	},
	equityRisk: {
		extractor: new FactExtractor([
			new LodashExtractor('risk.risk.factorContributors'),
			new LodashExtractor('risk.risk.total')
		], (contributors, totalRisk) => {
			const equityRiskContribution = contributors.find(contributor => contributor.name === 'Equity')?.contribution || 0;
			return (equityRiskContribution / totalRisk) * 100;
		})
	}
};
